import React, { useState } from "react";
import "components/modal/EditHeadingModal.scss";
import CommonModal from "components/Common/CommonModal";
import FormValidationError from "components/FormValidationError";
import "react-multi-email/dist/style.css";

const TransferOwnershipModal = ({ isOpen, onRequestClose, onApply, title }) => {
  const [error, setError] = useState();
  const [email, setEmail] = useState();

  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!value || !emailRegex.test(value)) {
      setError("Please enter a valid email address.");
      return false;
    } else {
      setError(null);
      return true;
    }
  };

  const handleApply = () => {
    validateEmail(email);
    if (!error) onApply(email);
  };

  return (
    <CommonModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={title}
      onApply={handleApply}
      onCancelText="Cancel"
      onApplyText="Transfer"
      classPrefix="plt"
    >
      <div className="plt-modal-body-content">
        <div className="plt-select-dropdown-wrapper dis-pl-24 dis-pr-24">
          <h6 className="plt-select-dropdown-title plt-ui-text-sm-medium dis-mb-4">
            Email address
          </h6>
          <div className="plt-input-wrapper">
            <input
              type="email"
              id="email"
              name="email"
              tabIndex={1}
              autoFocus={true}
              placeholder="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={`input-field-custom w-full ${
                error ? "border-red-500" : ""
              }`}
            />
            {error && <FormValidationError error={error} />}
          </div>
          <div className="plt-body-xs dis-mt-4">
            Note:- You can transfer account ownership only if the user is
            already signup in to the dessign.systems. Once you transfer account
            ownership, you will not have access to this design system.
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default TransferOwnershipModal;
